<template>
  <multiselect-item
    id="id_empresa"
    v-model="empresas"
    :custom-label="label"
    :options="empresasOptions"
    placeholder="Seleccione empresa"
    track-by="id_empresa"
    :loading="isLoading"
  ></multiselect-item>
</template>

<script>
import AdaptarVueModel from "./AdaptarVueModel";
import { get } from "lodash-es";

export default {
  name: "SelectorEmpresasDelCliente",
  props: ["value", "idCliente"],
  mixins: [AdaptarVueModel],
  data: () => ({
    empresasOptions: [],
    isLoading: true,
  }),
  mounted() {
    this.getData();
  },
  methods: {
    label(empresa) {
      return `${empresa.id_empresa} - ${empresa.RazonSocial}`;
    },
    async getData() {
      this.isLoading = true;
      const resp = await this.$store.dispatch(
        "Empresas/getEmpresas",
        this.idCliente,
      );
      if (resp.ok) {
        this.empresasOptions = get(resp, "result[0]", []);
        this.adaptarVueModel(this.empresasOptions, "id_empresa");
      }
      this.isLoading = false;
      return resp;
    },
  },
  computed: {
    empresas: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
